export const educationData = [
    {
        id: 1,
        institution: 'Hackbright Academy, San Francisco, CA.',
        course: 'Software Engineering Program - Accelerated.',
        startYear: 'June 2022',
        endYear: 'October 2022'
    },
    {
        id: 2,
        institution: 'Texas Tech University, Lubbock, TX.',
        course: 'Master of Science, Retail and Hospitality Management',
        startYear: '2020',
        endYear: '2022'
    },
    {
        id: 3,
        institution: 'Yaba College of Technology, Lagos.',
        course: 'Bachelor of Science, Hospitality Management',
        startYear: '2013',
        endYear: '2017'
    },
]